import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import styles from './css-grid.scss';
import classnames from 'classnames';
const getFractionString = (n, minItemWidth) => {
  const unit = minItemWidth ? "minmax(" + minItemWidth + "px, 1fr)" : '1fr';
  return Array(n).fill(unit).join(' ');
};
export class CSSGrid extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "containerClassName", this.props.styleId + "-" + this.props.gridId);
    _defineProperty(this, "containerRef", /*#__PURE__*/React.createRef());
    _defineProperty(this, "state", {
      isClient: false
    });
  }
  componentDidMount() {
    if (this.containerRef.current) {
      this.containerRef.current.style.gridTemplateColumns = '';
      this.containerRef.current.style.msGridColumns = '';
    }
    if (typeof window !== 'undefined') {
      this.setState({
        isClient: true
      });
    }
  }
  getCss() {
    const {
      rows = 1,
      cols = 1,
      minItemWidth
    } = this.props;
    let styleContent = "." + this.containerClassName + " {\n      grid-template-rows: " + getFractionString(rows) + ";\n      -ms-grid-rows: " + getFractionString(rows) + ";\n      -ms-grid-columns: " + getFractionString(cols, minItemWidth) + ";\n      grid-template-columns: " + getFractionString(cols, minItemWidth) + ";\n    }";
    for (let row = 1; row <= rows; row++) {
      for (let col = 1; col <= cols; col++) {
        const cellNum = col + cols * (row - 1);
        const cellStyle = "." + this.containerClassName + " > *:nth-child(" + cellNum + ") {-ms-grid-row: " + row + "; -ms-grid-column: " + col + ";}";
        styleContent += cellStyle;
      }
    }
    return styleContent;
  }
  render() {
    const {
      style,
      children
    } = this.props;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", {
      key: this.state.isClient ? 'first-pass' : 'second-pass'
    }, this.getCss()), /*#__PURE__*/React.createElement("div", {
      ref: this.containerRef,
      className: classnames(styles.container, this.containerClassName),
      style: style
    }, children));
  }
}
//# sourceMappingURL=css-grid.js.map